import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GemininotesPopupComponent } from './gemininotes-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [GemininotesPopupComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    HttpClientModule,
  ],
  exports: [GemininotesPopupComponent],
})
export class GemininotesPopupModule { }
